// extracted by mini-css-extract-plugin
export default {"selectableTextarea":"useCopyableText-selectableTextarea-UM55z"};